// ----------- import external dependencies -----------
import React, { useEffect, useState } from "react";

// ----------- import internal dependencies ------------
import AccordionDropDown from "../../../../../components/AccordionDropdown";
import { formatCamelCaseReg } from "../../../../../shared/sharedConstants";

interface Permission {
  permissionLabel: string;
  permissionValue: boolean;
  canEdit: boolean;
  apiName: string;
}

interface AccordionInputProps {
  ele: [string, Permission[]];
  setPermissionList: React.Dispatch<React.SetStateAction<any>>;
}

const AccordionInput: React.FC<AccordionInputProps> = ({
  ele,
  setPermissionList,
}) => {
  const [permissions, setPermissions] = useState(ele[1]);

  useEffect(() => {
    setPermissions(ele[1]);
  }, [ele]);

  const handleCheckboxChange =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const updatedPermissions = [...permissions];
      updatedPermissions[index].permissionValue = e.target.checked;
      setPermissions(updatedPermissions);
      setPermissionList((prev: any) => ({
        ...prev,
        [updatedPermissions[index].apiName]: e.target.checked,
      }));
    };

  return (
    <AccordionDropDown
      heading={
        <div className="role-wrapper opac mb-2">
          <span className="block font-inter text-black text-purple-300">
            {formatCamelCaseReg(ele[0])}
          </span>
        </div>
      }
    >
      {permissions.map((elem, ind) => (
        <div
          key={elem.permissionLabel}
          className={`role-wrapper py-2 pl-4 ${!elem.permissionValue ? "opacity-60" : ""}`}
        >
          <input
            type="checkbox"
            id={elem.permissionLabel}
            className="accent-purple-light"
            checked={elem.permissionValue}
            disabled={!elem.canEdit}
            onChange={handleCheckboxChange(ind)}
          />
          <label
            htmlFor={elem.permissionLabel}
            className="font-inter text-black text-purple-300"
          >
            {elem.permissionLabel}
          </label>
        </div>
      ))}
    </AccordionDropDown>
  );
};

export default AccordionInput;
